export default function RaceFormat() {
  return (
    <section id="formato" className="py-16 sm:py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">
            Formato de Corridas
          </h2>
          <p className="text-base sm:text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
            Cada série possui seu próprio formato de corrida, garantindo competitividade e emoção em todas as etapas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Série A */}
          <div className="bg-gray-800 p-8 rounded-xl border-2 border-orange-500">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
                <i className="ri-vip-crown-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold">Série A</h3>
            </div>
            
            <div className="space-y-6">
              <div className="bg-gray-900 p-6 rounded-lg">
                <h4 className="text-xl font-bold text-orange-500 mb-4">Bateria 1 — Sprint</h4>
                <ul className="space-y-3">
                  <li className="flex items-center">
                    <i className="ri-time-line text-orange-500 text-xl mr-3"></i>
                    <span className="text-gray-300">Qualifying 1</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-flag-line text-orange-500 text-xl mr-3"></i>
                    <span className="text-gray-300">Corrida 1: <strong className="text-white">15 minutos</strong></span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-900 p-6 rounded-lg">
                <h4 className="text-xl font-bold text-orange-500 mb-4">Bateria 2 — Principal</h4>
                <ul className="space-y-3">
                  <li className="flex items-center">
                    <i className="ri-time-line text-orange-500 text-xl mr-3"></i>
                    <span className="text-gray-300">Qualifying 2</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-flag-line text-orange-500 text-xl mr-3"></i>
                    <span className="text-gray-300">Corrida 2: <strong className="text-white">45 minutos</strong></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Série B */}
          <div className="bg-gray-800 p-8 rounded-xl border-2 border-orange-500">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-lg mr-4">
                <i className="ri-trophy-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold">Série B</h3>
            </div>
            
            <div className="space-y-6">
              <div className="bg-gray-900 p-6 rounded-lg">
                <h4 className="text-xl font-bold text-orange-500 mb-4">Bateria Única</h4>
                <ul className="space-y-3">
                  <li className="flex items-center">
                    <i className="ri-time-line text-orange-500 text-xl mr-3"></i>
                    <span className="text-gray-300">Qualifying conforme regulamento/briefing da etapa</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-flag-line text-orange-500 text-xl mr-3"></i>
                    <span className="text-gray-300">Corrida única: <strong className="text-white">45 minutos</strong></span>
                  </li>
                </ul>
              </div>

              <div className="bg-orange-500/10 border-l-4 border-orange-500 p-4 rounded">
                <p className="text-sm text-gray-300">
                  <strong className="text-orange-500">Nota:</strong> Apenas 1 bateria por etapa na Série B.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
